import Swiper from 'swiper';

import {Navigation} from 'swiper/modules';

import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/effect-fade';

import _ from '@app/utils.js'

_.onElementReady('.field-news-slider', field => {
  const wrapper = field.closest('.news-slider-wrapper')
  const swiper = new Swiper(field, {
    modules: [Navigation],
    slidesPerView: "auto",
    spaceBetween: 30,
    navigation: {
      nextEl: wrapper.querySelector('.swiper-button-next'),
      prevEl: wrapper.querySelector('.swiper-button-prev'),
    },
  });
})

// Su mobile il form esposto delle news diventa un drawer di filtri.
// Views (AJAX) ricrea il form a ogni scelta: la behavior lo riattacca ogni volta.
Drupal.behaviors.diemmebiNewsFilters = {
  attach(context) {
    once('diemmebi-news-filters', '.page-node-type-news-list .views-exposed-form', context).forEach(form => {
      const setOpen = open => {
        form.classList.toggle('filters-open', open)
        document.body.classList.toggle('filters-drawer-open', open)
      }

      const toggle = document.createElement('button')
      toggle.type = 'button'
      toggle.className = 'filters-toggle d-lg-none'
      toggle.textContent = Drupal.tt('Filtri')
      toggle.addEventListener('click', () => setOpen(true))

      const header = document.createElement('div')
      header.className = 'filters-drawer-header d-lg-none'
      header.innerHTML = '<span></span><button type="button" class="filters-drawer-close">×</button>'
      header.querySelector('span').textContent = Drupal.tt('Filtri')
      const close = header.querySelector('button')
      close.setAttribute('aria-label', Drupal.tt('Chiudi'))
      close.addEventListener('click', () => setOpen(false))

      form.prepend(header)
      form.prepend(toggle)

      form.addEventListener('change', () => setOpen(false))
    })
  },
}

_.onDocumentReady(() => Drupal.behaviors.diemmebiNewsFilters.attach(document))
